var React = require('react');

function BabyCarriage (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96 384a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm256 0a64 64 0 1 0 64 64 64 64 0 0 0-64-64zM90.8 7.61C35.3 51.91 0 118 0 192h256L144.8 17c-11.3-17.79-37.2-22.79-54-9.39z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M496 96h-48a64.06 64.06 0 0 0-64 64v64H0a191.44 191.44 0 0 0 56.82 136.34 96.07 96.07 0 0 1 129.68 55.58c1.83.05 3.66.08 5.5.08h64c1.84 0 3.67 0 5.5-.08a96.07 96.07 0 0 1 129.68-55.58A191.44 191.44 0 0 0 448 224v-64h48a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

BabyCarriage.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = BabyCarriage;

BabyCarriage.default = BabyCarriage;
